import {
  APIAnalyticsReport,
  APIAnalyticsEvent,
  APIAnalyticsOptions,
  APIAnalyticsSavedReport
} from 'src/model/api/analytics/APIAnalytics'
import {
  AnalyticsReport,
  AnalyticsEvent,
  AnalyticsOptions,
  AnalyticsSavedReport
} from 'src/model/analytics/Analytics'

export namespace AnalyticsModel {

  export const analyticsReportFromAPIModel = (apiAnalyticsReport: APIAnalyticsReport) => {
    const report: AnalyticsReport = {
      id: apiAnalyticsReport.report_id,
      name: apiAnalyticsReport.report_name,
    }
    return report
  }

  export const analyticsEventFromAPIModel = (apiAnalyticsEvent: APIAnalyticsEvent) => {
    const event: AnalyticsEvent = apiAnalyticsEvent
    return event
  }

  export const analyticsOptionsFromAPIModel = (apiAnalyticsOptions: APIAnalyticsOptions) => {
    const analyticsOptions: AnalyticsOptions = {
      dateFormat: apiAnalyticsOptions.date_format,
      reportType: apiAnalyticsOptions.report_type,
      fields: apiAnalyticsOptions.fields,
      presentations: apiAnalyticsOptions.presentations,
      teams: apiAnalyticsOptions.teams,
      users: apiAnalyticsOptions.users,
      sessionID: apiAnalyticsOptions.session_id,
      userID: apiAnalyticsOptions.user_id
    }
    return analyticsOptions
  }

  export const analyticsSavedReportFromAPIModel = (apiAnalyticsSavedReport: APIAnalyticsSavedReport) => {
    const savedReport: AnalyticsSavedReport = {
      id: apiAnalyticsSavedReport.id,
      companyUUID: apiAnalyticsSavedReport.company_uuid,
      name: apiAnalyticsSavedReport.name,
      description: apiAnalyticsSavedReport.description,
      urlParams: apiAnalyticsSavedReport.url_params,
      params: analyticsOptionsFromAPIModel(apiAnalyticsSavedReport.params!),
      isExtract: apiAnalyticsSavedReport.is_extract!,
      exportFrequency: apiAnalyticsSavedReport.export_frequency,
      exportRecipients: apiAnalyticsSavedReport.export_recipients,
      updatedAt: apiAnalyticsSavedReport.updated_at,
      createdAt: apiAnalyticsSavedReport.created_at,
      companyID: apiAnalyticsSavedReport.company,
      updatedBy: apiAnalyticsSavedReport.updated_by,
      createdBy: apiAnalyticsSavedReport.created_by,
    }
    return savedReport
  }
}
